import Vue from 'vue'
import {Button,Table,AutoComplete,Input,Icon,Select,Popconfirm} from 'ant-design-vue'
import { createNamespacedHelpers  } from 'vuex'
const {Option} = Select;
Vue.use(Input)
import {util} from '@utils'
import CommonFramework from "@/shared/components/lyCommonFramework/index";
import pageOption from "./pageOption";
import cookie from 'js-cookie'

const {mapActions,mapState } = createNamespacedHelpers('pages/empManage')
const data = [{
    id: '1',
    userName: 'John Brown',
    roleNames: ['标准角色'],
    status:0,
    mt: '2019-9-17 14:20',
    tags: ['nice', 'developer'],
    roleType:0
}, {
    id: '2',
    userName: 'Jim Green',
    roleNames: [],
    status:1,
    mt: '2019-9-17 14:20',
    tags: ['loser'],
    roleType:0
}, {
    id: '3',
    userName: 'Joe Black',
    roleNames: ['标准角色','客服'],
    status:0,
    mt: '2019-9-17 14:20',
    tags: ['cool', 'teacher'],
    roleType:0
}];
export default {
    components:{Button,Table,CommonFramework,AutoComplete,Icon,Select,Option,Popconfirm},
    mixins: [ pageOption ],
    data() {
        return {
            isChildRoute: false,
            rowKey: 'id',
            rowSelection:{},
            searchValue:'',
            roleChange:'',
            stateChange:'',
            columnsDFW: [{
                    title: 'B账号',
                    dataIndex: 'userName',
                    align: 'center',
                },{
                    title: '昵称',
                    dataIndex: 'nickName',
                    align: 'center',
                }, {
                    title: 'w账号',
                    dataIndex: 'oldLoginName',
                    align: 'center',
                },{
                    title: '归属',
                    dataIndex: 'source',
                    align: 'center',
                }, {
                    title: '全部角色',
                    dataIndex: 'roleNames',
                    align: 'center',
                    // slots: { title: 'customAge' },
                    // width: 130,
                },{
                    // title: '全部状态',
                    dataIndex: 'status',
                    align: 'center',
                    scopedSlots: { customRender: 'type' },
                    slots: { title: 'customType' },
                    width: 110
                }, {
                    title: '修改时间',
                    dataIndex: 'mt',
                    align: 'center',
                    width: 100,
                }, {
                    title: '操作',
                    align: 'center',
                    scopedSlots: { customRender: 'operation' },
                    width: 80
                }
            ],
            columns: [{
                title: 'B账号',
                dataIndex: 'userName',
                align: 'center',
            },{
                title: '昵称',
                dataIndex: 'nickName',
                align: 'center',
            },{
                title: 'w账号',
                dataIndex: 'oldLoginName',
                align: 'center',
            }, {
                title: '绑定手机号',
                dataIndex: 'phone',
                align: 'center',
            },{
                title: '全部角色',
                dataIndex: 'roleNames',
                align: 'center',
                // slots: { title: 'customAge' },
                // width: 130,
            },{
                // title: '全部状态',
                dataIndex: 'status',
                align: 'center',
                scopedSlots: { customRender: 'type' },
                slots: { title: 'customType' },
                // width: 110
            }, {
                title: '修改时间',
                dataIndex: 'mt',
                align: 'center',
                width: 100,
            }, {
                title: '操作',
                align: 'center',
                scopedSlots: { customRender: 'operation' },
                width: 180
            }],
            isLoading:false
        }
    },
    async mounted() {
        // this.empList = this.data
        // this.pageOption.total = this.empListCount
    },
    watch:{
        $route:{
            immediate:true,
            async handler(newVal){
                if (newVal.name === 'lyEmpAdd') {
                    this.isChildRoute = true;
                } else {
                    this.isChildRoute = false;
                    // let aid = cookie.get('id')
                    // await this.listAllRoles({params:{aid}})
                    await this.startRequest()

                }
            }
        },
        // empListCount:{
        //     immediate:true,
        //     handler(newVal){
        //         this.pageOption.total = newVal
        //     }
        // }
    },
    methods: {
        ...mapActions(['getEmpList','listAllRoles','changeEmpStatus','unBindTenantStatus']),
        async modifyState(record){
            this.isLoading = true;
            let res = await this.changeEmpStatus({param:{
                    empId:record.id,
                    status:record.status*1===0?'1':'0',
                }})
            this.isLoading = false;
            if (res.code * 1 === 1) {
                this.$message.success('操作成功');
                this.startRequest()
            } else {
                this.$message.error(res.msg)
            }
        },
        routeJump(type,id,userName){
            let query = type==='edit'?{id}:{}
            this.isChildRoute = true;
            // this.$router.push({path:`/my/empManage/${type}`,query});
            this.$router.push({name:'lyEmpAdd',params:{type,userName},query});
        },
        handleChangeR(value) {
            this.pageOption.current = 1
            this.roleChange = value
            this.startRequest()
        },
        handleChangeS(value) {
            this.pageOption.current = 1
            this.stateChange = value
            this.startRequest()
        },
        onSearch(value) {
            // this.searchValue =value;
            this.pageOption.current = 1
            this.startRequest()
        },
        async startRequest(){
            const {current,pageSize} = this.pageOption;
            let aid = cookie.get('id')
            let params = {
                aid,
                pageIndex:current, //页数
                pageSize:pageSize,
                userName:this.searchValue,
                status:this.stateChange,
                // rid:this.roleChange,
                // nickName:'',//暂无用
            };
            Object.keys(params).forEach(key=>{
                if(!params[key]){
                    Reflect.deleteProperty(params,key)
                    // delete params[key]
                }
            })
            await this.getEmpList({params:JSON.stringify(params)})
            this.pageOption.total = this.empListCount
        },
        // 员工解绑租户(删除按钮)
        async unBindTenant(value) {
            this.isLoading = true;
            let res = await this.unBindTenantStatus({param:{
                uid:value
            }})
            this.isLoading = false;
            if(res.code * 1 === 1) {
                this.$message.success('操作成功')
                this.startRequest()
            } else {
                this.$message.error(res.msg)
            }
        }
     },
    computed:{
        ...mapState({
            empList: state => state.empList,
            // empList: state => data,
            rolesList: state => state.rolesList,
            empListCount: state => state.empListCount,
        }),
        column() {
            const buzzType = (cookie.get('buzzType')) * 1
            const buzzId = (cookie.get('buzzId')) * 1
            const parentBuzzId = (cookie.get('parentBuzzId')) * 1
            return ((buzzType === 5 || buzzType === 6) && buzzId === parentBuzzId) ? this.columnsDFW : this.columns
        }
    }
}
